import   React, 
       { useState, 
         useEffect, 
         useRef                 }   from "react";
import { useLoader              }   from "components/Covers/loadingCover";
import { useInfoMsgModal        }   from "components/Covers/infoMessageModal";
import { useToastMessage        }   from "components/Covers/toastMessage";
import   MainStyle                  from "components/UI/main.module.scss";
import { getOrdersResByIDSet    }   from "./orderDocumentService";
import { Select                 }   from "antd";
import   BtnChangeTheme             from "components/Buttons/Theme/BtnTheme";
import { getImgSrc,         
         DefaultLoadingLogo, 
         getFileSrc,
         GetLabel,
         toSafeFilename         }   from "Utilities/utils";
const {  PDFExport, PDFMargin   }   = require("@progress/kendo-react-pdf");

let appLang = null;

// #region Layout Helppers
const DropdownList = ({
    className,
    style,
    onChange,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value}) => {
  return (
    <Select
      name={name}
      id={id}
      placeholder={placeholder}
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      options={listOfItems}
      className={className}
      style={style}
      onChange={onChange}
      defaultValue={defaultValue}
      title={title}
      popupClassName={popupClassName}
      value={value}
    />
  );
};
const DefaultPadding = () =>{
    return(<div className={MainStyle.py_3}/>);
};
const PageBreak = React.memo(() => {
    return (
        <div className={"page-break content-wrapper"}/>
    );
});
// #endregion

// #region InfoBlock
const InfoBlock = React.memo(({...other}) => {
    const { data, fontSize, lang } = other;

    const MainHeader = () => {
        return(
            <>
                <div className={MainStyle.row}>
                    {((data?.LOGO1 != 0) && (data?.LOGO1 != null) && (data?.LOGO1_DATA != "") && (data?.LOGO1_DATA != null)) && (
                        <div className={[MainStyle.col].join(" ")}>
                            <div className={[MainStyle.d_flex,  MainStyle.justify_content_center, MainStyle.align_items_center].join(" ")}>
                                <img style={{  objectFit: 'scale-down', objectPosition: '50% 50%'}} 
                                     className={MainStyle.answer_logo}
                                     src={getImgSrc(data?.LOGO1_DATA)}
                                />
                            </div>
                        </div>
                    )}
                    {((data?.LOGO2 != 0) && (data?.LOGO2 != null) && (data?.LOGO2_DATA != "") && (data?.LOGO2_DATA != null)) && (
                        <div className={[MainStyle.col].join(" ")}>
                            <div className={[MainStyle.d_flex,  MainStyle.justify_content_center, MainStyle.align_items_center].join(" ")}>
                                <img style={{  objectFit: 'scale-down', objectPosition: '50% 50%'}} 
                                     className={MainStyle.answer_logo}
                                     src={getImgSrc(data?.LOGO2_DATA)}
                                />
                            </div>
                        </div>
                    )}
                    {((data?.LOGO3 != 0) && (data?.LOGO3 != null) && (data?.LOGO3_DATA != "") && (data?.LOGO3_DATA != null)) && (
                        <div className={[MainStyle.col].join(" ")}>
                            <div className={[MainStyle.d_flex,  MainStyle.justify_content_center, MainStyle.align_items_center].join(" ")}>
                                <img style={{  objectFit: 'scale-down', objectPosition: '50% 50%'}} 
                                     className={MainStyle.answer_logo}
                                     src={getImgSrc(data?.LOGO3_DATA)}
                                />
                            </div>
                        </div>                        
                    )}
                </div>
                <DefaultPadding/>
                <div className={MainStyle.row}>
                    <div className={[MainStyle.col_lg].join(" ")}>
                        <div className={[MainStyle.rounded_5, MainStyle.border].join(" ")} style={{backgroundColor: "#e6e6e6"}}>
                            <div className={[MainStyle.py_2, MainStyle.text_center].join(" ")}>
                                <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                                    {`${GetLabel(lang, 507)}: ${data.SUBMISSIONS} ${GetLabel(lang, 508)}`}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            {
                data !== null ?
                            <MainHeader/>
                :   
                    null
            }
        </>
    );

});

const HeaderBlock = React.memo(({...other}) => {
    const { data,
            lang,
            fontSize                       } = other;

    return (
        <>
            {data !== null && (
                <>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={[MainStyle.text_start].join(" ")}>
                                <span className={[MainStyle[`fs_${fontSize - 3}`],                                                   
                                                  MainStyle.fw_semibold].join(" ")}>
                                    {data[`HEADER_LANG_${lang}_DESC_1`]}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <p className={[MainStyle[`fs_${fontSize}`], MainStyle.fw_semibold, MainStyle.text_start].join(" ")}>
                                {data[`HEADER_LANG_${lang}_DESC_2`]}
                            </p>
                            <p className={[MainStyle[`fs_${fontSize}`], MainStyle.fw_semibold, MainStyle.text_start].join(" ")}>
                                {data[`HEADER_LANG_${lang}_DESC_3`]}
                            </p>
                            <p className={[MainStyle[`fs_${fontSize}`], MainStyle.text_start].join(" ")}>
                                {data[`HEADER_LANG_${lang}_DESC_4`]}
                            </p>
                        </div>
                    </div>
                </>

            )}
        </>
    );

});
// #endregion

// #region Session Line
const TeacherLine = React.memo(({data, lang, fontSize}) => {
    return (
        <>
            <div className={MainStyle.mx_2}>
                <div>
                    <span className={[MainStyle[`fs_${fontSize}`], MainStyle.fw_semibold].join(" ")}>
                        {data[`DESIGNATION_${lang}_DESC`]}:
                    </span>
                </div>
                <div>
                    <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                        { data.FULL_NAME }
                    </span>
                </div>
            </div>
        </>
    );
});


const TeacherLineAvatar = React.memo(({data, lang, fontSize}) => {
    return (
        <>
            {((data.FILE_DATA !== "") && (data.FILE_DATA !== null)) && (
                <>
                    <div className={[MainStyle.d_flex, MainStyle.justify_content_end, MainStyle.my_3].join(" ")}>
                            <div    style={{overflowX: 'hidden', overflowY: 'hidden'}}
                                    className={[MainStyle.border,
                                                MainStyle.shadow_sm, 
                                                MainStyle.rounded_circle, 
                                                MainStyle.teacher_avatar].join(" ")} 
                            >
                                <img src={getFileSrc(data.FILE_DATA)} style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}/>    
                            </div>
                    </div>  
                </>
            )}
        </>
    );
});

const LabelLine = React.memo(({data, lang, fontSize}) => {
    return (
        <>
            <div className={MainStyle.mx_2}>
                <div>
                    <span className={[MainStyle[`fs_${fontSize}`], MainStyle.fw_semibold].join(" ")}>
                        {data[`LBL_LANG_${lang}_DESC`] !== "" ?
                            data[`LBL_LANG_${lang}_DESC`] + ':'
                            : 
                            null
                        }
                    </span>
                </div>
                <div>
                    <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                        {data[`TXT_LANG_${lang}_DESC`]}
                    </span>
                </div>
            </div>
        </>
    );
});

const SessionLine = React.memo(({...other}) => {
    const { data,
            index,      
            lang,
            fontSize                 } = other;
    return (
        <>
            {
                data?.TYPE_ID === 5 ?
                    <div className={MainStyle.my_1}>
                        <TeacherLine data={data} lang={lang} fontSize={fontSize}/>
                    </div>
                :            
                data?.TYPE_ID === 6 ? 
                    <div className={MainStyle.my_1}>
                        <LabelLine data={data} lang={lang} fontSize={fontSize}/>
                    </div>
                :
                null
            }
        </>
    );

});
// #endregion

// #region Question Type 1
const QType_1 = React.memo(({...other}) => {
    const { orderData, lang, fontSize, block} = other;

    useEffect(() => {

    }, [lang, fontSize, block]);

    function tHeadStar (d) {
        return (
            <React.Fragment>
                <div className={[MainStyle.d_flex, MainStyle.align_middle].join("")}>
                    <span className={[MainStyle[`fs_${fontSize}`], MainStyle.text_white].join(" ")}>
                        {d}
                    </span>
                    <svg viewBox="0 0 576 512" style={{width: `1.0rem`, height: `1.0rem`}}>
                        <path style={{fill: "#fff"}} d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/>
                    </svg>
                </div>
            </React.Fragment>
        );
    }
    function tdBodyAnswers (item) {
        return (
            <React.Fragment>
                <td className={[MainStyle.align_middle, MainStyle.border_end].join(" ")}>
                    <div className={MainStyle.text_black + " " + MainStyle.text_center}>
                        {item.OCCURRENCES}
                    </div>
                </td>
            </React.Fragment>
        );
    }
    function countedData(items) {
        let i = 0, t = 0, o = 0;
        let avg = 0, stdDev = 0;

        while (i < items.length) {            
            t += (items[i].OPTION_VALUE * items[i].OCCURRENCES);
            o += items[i].OCCURRENCES;
            i++;
        }

        if (o > 0) {
            avg = t / o;

            let varianceSum = 0;
            for (let j = 0; j < items.length; j++) {
                let diff = items[j].OPTION_VALUE - avg;
                varianceSum += items[j].OCCURRENCES * diff * diff;
            }
            stdDev = Math.sqrt(varianceSum / o);
            stdDev = lang == "EN" ? stdDev.toFixed(1).toString() : (stdDev.toFixed(1).toString()).replaceAll('.', ',');
            avg = lang === "EN" ? avg.toFixed(1).toString() : (avg.toFixed(1).toString()).replaceAll('.', ',');
        }

        return (
            <React.Fragment>
                <td className={[MainStyle.align_middle].join(" ")}>
                    <div className={MainStyle.text_black + " " + MainStyle.text_center}>
                        {avg}
                    </div>
                </td>
                {/*
                    <td className={MainStyle.align_middle}>
                        <div className={MainStyle.text_black + " " + MainStyle.text_center}>
                            {stdDev}
                        </div>
                    </td>
                */}
            </React.Fragment>
        );
    }
    function questionRow(q) {
        return (
            <tr>
                <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.row}>
                    <span className={tableFontStyle  + " " + MainStyle.text_black}>
                        {q.PREFIX} {q[`QUESTION_LANG_${lang}_DESC`]}
                    </span>                    
                </th>
                {q?.ANSWERS.map((item) => {
                        return (tdBodyAnswers(item));
                })}
                {countedData(q?.ANSWERS)}
            </tr>
        );
    }
    function getObservations(item) {
        let obs = [];
        if (item.OBSERVATIONS) {
            obs = item.OBSERVATIONS.split("|n|");
        }        
        return (
            <React.Fragment>
                {item.OBSERVATIONS !== "" && (
                    <React.Fragment>
                    <div>
                        <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                            {GetLabel(lang, 513)} {item[`OPTION_LANG_${lang}_DESC`]}: 
                        </span>
                    </div>                    
                    {obs.map((item, i) => {
                        return(
                            <div className={MainStyle.text_wrap}>
                                <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                                    {i + 1} {item}
                                </span>
                            </div>
                        );
                    })}
                    </React.Fragment>
                )}
            </React.Fragment>
        );

    }
    const tableFontStyle = [MainStyle[`fs_${fontSize}`], MainStyle.fw_normal].join(" ");

    return (
        <React.Fragment>
            {block  && (
                block?.Content.length > 0 ?
                    <React.Fragment>
                            <div className={[MainStyle.table_responsive, MainStyle.rounded_top_3].join(" ")}>
                                <table className={[MainStyle.table, MainStyle.table_striped_document_export].join(" ")}>
                                    <thead style={{backgroundColor: "rgb(110, 110, 110)"}}>
                                        <tr>
                                            <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col} style={{ width: "30rem" }}/>
                                            <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col}>
                                                <div className={MainStyle.text_center}>
                                                    {tHeadStar(1)}
                                                </div>
                                            </th>
                                            <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col}>
                                                <div className={MainStyle.text_center}>
                                                    {tHeadStar(2)}
                                                </div>
                                            </th>
                                            <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col}>
                                                <div className={MainStyle.text_center}>
                                                    {tHeadStar(3)}
                                                </div>
                                            </th>
                                            <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col}>
                                                <div className={MainStyle.text_center}>
                                                    {tHeadStar(4)}
                                                </div>
                                            </th>
                                            <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col}>
                                                <div className={MainStyle.text_center}>
                                                    {tHeadStar(5)}
                                                </div>
                                            </th>
                                            <th className={[MainStyle.align_middle].join(" ")} scope={MainStyle.col}>
                                                <div className={MainStyle.text_center}>
                                                    <span className={tableFontStyle + " " + MainStyle.text_white}>
                                                        {GetLabel(lang, 510)}
                                                    </span>
                                                </div>
                                            </th>
                                            {/*
                                                <th className={[MainStyle.align_middle].join(" ")} scope={MainStyle.col}>
                                                    <div className={MainStyle.text_center}>
                                                        <span className={tableFontStyle + " " + MainStyle.text_white}>
                                                            {GetLabel(lang, 511)}
                                                        </span>
                                                    </div>
                                                </th>
                                            */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {block.Content.map((question) => {
                                            return(
                                                questionRow(question)
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            {orderData?.OBSERVATIONS === "Y" ?
                                <React.Fragment>
                                    <DefaultPadding/>
                                    <div className={MainStyle.border_top}>
                                        <div className={MainStyle.mt_3}>
                                            <span className={tableFontStyle + " " + MainStyle.text_black + " " + MainStyle.mx_2}>
                                                {GetLabel(lang, 512)}
                                            </span>                                
                                        </div>
                                        <div className={MainStyle.mb_3}>
                                            <div className={MainStyle.mx_2}>
                                                {block?.Content.map((question, i) => {
                                                    return(
                                                        <React.Fragment>
                                                            <div>
                                                                <span className={tableFontStyle  + " " + MainStyle.text_black}>
                                                                    {i + 1} - {question[`QUESTION_LANG_${lang}_DESC`]}
                                                                </span>
                                                            </div>
                                                            <div className={MainStyle.mx_2}>
                                                                {question?.ANSWERS.map((answer) => {
                                                                    return(
                                                                        getObservations(answer)
                                                                    )
                                                                })}
                                                            </div>
                                                        </React.Fragment>
                                                    );
                                                })}
                                                {
                                                //getObservations(question)
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            :
                                null
                            }
                    </React.Fragment>
                :
                    <div className={MainStyle.text_start}>
                        <span className={[MainStyle[`fs_${fontSize - 3 }`], MainStyle.fw_semibold].join(" ")}>
                            {block.PREFIX} {block.Header[`QUESTION_LANG_${lang}_DESC`]}
                        </span>
                    </div>
            )}
        </React.Fragment>
    );

});
// #endregion

// #region Question Type 2
const QType_2 = React.memo(({...other}) => {
    const { orderData, lang, fontSize, block} = other;

    useEffect(() => {}, [lang, fontSize, block]);

    function bodyAnswers (item) {
        let arr = item.ANSWERS.split('|n|');
        return (
            arr.map((item, i) => {
                return(
                    <div className={[MainStyle.text_wrap, MainStyle.my_3].join(" ")}>
                        <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                            {`${i + 1}. ${item}`}
                        </span>
                    </div>
                );
            })
        );
    }
    function getObservations(item) {
        let obs = [];
        if (item.OBSERVATIONS) {
            obs = item.OBSERVATIONS.split("|n|");
        }        
        return (
            <React.Fragment>
                {item.OBSERVATIONS !== "" && (
                    <React.Fragment>
                    <div>
                        <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                            {GetLabel(lang, 513)} {item[`OPTION_LANG_${lang}_DESC`]}: 
                        </span>
                    </div>                    
                    {obs.map((item, i) => {
                        return(
                            <div className={MainStyle.text_wrap}>
                                <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                                    {i + 1} {item}
                                </span>
                            </div>
                        );
                    })}
                    </React.Fragment>
                )}
            </React.Fragment>
        );

    }
    const fontStyle = [MainStyle[`fs_${fontSize}`], MainStyle.fw_normal].join(" ");

    return (
        <React.Fragment>
            {block  && (
                <React.Fragment>
                    <div className={[MainStyle.row, MainStyle.rounded_top_3].join(" ")} style={{backgroundColor: "rgb(110, 110, 110)"}}>
                        <div className={MainStyle.col}>
                            <div className={MainStyle.m_2}>
                                <span className={[MainStyle[`fs_${fontSize}`], MainStyle.fw_normal, MainStyle.text_white].join(" ")}>
                                    {`${block.Header.PREFIX}`} {block.Header[`QUESTION_LANG_${lang}_DESC`]}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col}>
                            <div className={MainStyle.m_2}>
                                        {block?.Content.ANSWERS.map((item) => {
                                                return (bodyAnswers(item));
                                        })}
                            </div>
                        </div>
                    </div>
                    {orderData?.OBSERVATIONS === "Y" ?
                        <React.Fragment>
                            <DefaultPadding/>
                            <div className={MainStyle.border_top}>
                                <div className={MainStyle.mt_3}>
                                    <span className={fontStyle + " " + MainStyle.mx_2}>
                                        {GetLabel(lang, 512)}
                                    </span>                                
                                </div>
                                <div className={MainStyle.mb_3}>
                                    <div className={MainStyle.mx_2}>
                                        {block?.Content.ANSWERS.map((item) => {
                                                return (getObservations(item));
                                        })}
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    :
                        null
                    }
                </React.Fragment>
            )}
        </React.Fragment>
    );

});
// #endregion

// #region Question Type 3
const QType_3 = React.memo(({...other}) => {
    const { orderData, lang, fontSize, block} = other;

    useEffect(() => {}, [lang, fontSize, block]);

    function tdBodyAnswers (i, item) {
        return (
            <tr>
                <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.row}>
                    <span className={tableFontStyle + " " + MainStyle.text_black}>
                        {i + 1} - {item[`OPTION_LANG_${lang}_DESC`]}
                    </span>                    
                </th>
                <td className={[MainStyle.align_middle, MainStyle.border_end].join(" ")}>
                    <div className={MainStyle.text_black + " " + MainStyle.text_center}>
                        {item.OPTION_VALUE}
                    </div>
                </td>
                <td className={[MainStyle.align_middle, MainStyle.border_end].join(" ")}>
                    <div className={MainStyle.text_center}>
                        <span className={tableFontStyle + " " + MainStyle.text_black}>
                           {item.OCCURRENCES}
                        </span>
                    </div>
                </td>
                {countedData(block?.Content.ANSWERS)}
            </tr>
        );
    }
    function countedData(items) {
        let i = 0, t = 0, o = 0;
        let avg = 0, stdDev = 0;

        while (i < items.length) {
            t += (items[i].OPTION_VALUE * items[i].OCCURRENCES);
            o += items[i].OCCURRENCES;
            i++;
        }

        if (o > 0) {
            avg = t / o;

            let varianceSum = 0;
            for (let j = 0; j < items.length; j++) {
                let diff = items[j].OPTION_VALUE - avg;
                varianceSum += items[j].OCCURRENCES * diff * diff;
            }
            stdDev = Math.sqrt(varianceSum / o);
            stdDev = lang == "EN" ? stdDev.toFixed(1).toString() : (stdDev.toFixed(1).toString()).replaceAll('.', ',');
            avg = lang === "EN" ? avg.toFixed(1).toString() : (avg.toFixed(1).toString()).replaceAll('.', ',');
        }

        return (
            <React.Fragment>
                <td className={[MainStyle.align_middle].join(" ")}>
                    <div className={MainStyle.text_black + " " + MainStyle.text_center}>
                        {avg}
                    </div>
                </td>
                {/*
                    <td className={MainStyle.align_middle}>
                        <div className={MainStyle.text_black + " " + MainStyle.text_center}>
                            {stdDev}
                        </div>
                    </td>
                */}
            </React.Fragment>
        );
    }
    function getObservations(item) {
        let obs = [];
        if (item.OBSERVATIONS) {
            obs = item.OBSERVATIONS.split("|n|");
        }        
        return (
            <React.Fragment>
                {item.OBSERVATIONS !== "" && (
                    <React.Fragment>
                    <div>
                        <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                            {GetLabel(lang, 513)} {item[`OPTION_LANG_${lang}_DESC`]}: 
                        </span>
                    </div>                    
                    {obs.map((item, i) => {
                        return(
                            <div className={MainStyle.text_wrap}>
                                <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                                    {i + 1} {item}
                                </span>
                            </div>
                        );
                    })}
                    </React.Fragment>
                )}
            </React.Fragment>
        );

    }
    const tableFontStyle = [MainStyle[`fs_${fontSize}`], MainStyle.fw_normal].join(" ");

    return (
        <React.Fragment>
            {block  && (
                <React.Fragment>
                    <div className={[MainStyle.table_responsive, MainStyle.rounded_top_3].join(" ")}>
                        <table className={[MainStyle.table, MainStyle.table_striped_document_export].join(" ")}>
                            <thead style={{backgroundColor: "rgb(110, 110, 110)"}}>
                                <tr>
                                    <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col} style={{ width: "35rem" }}>
                                        <div className={MainStyle.text_start}>
                                            <span className={tableFontStyle + " " + MainStyle.text_white}>
                                                {block.Header[`QUESTION_LANG_${lang}_DESC`]}
                                            </span>
                                        </div>
                                    </th>
                                    <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col}>
                                        <div className={MainStyle.text_center}>
                                            <span className={tableFontStyle + " " + MainStyle.text_white}>
                                                {GetLabel(lang, 179)}
                                            </span>
                                        </div>
                                    </th>
                                    <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col}>
                                        <div className={MainStyle.text_center}>
                                            <span className={tableFontStyle + " " + MainStyle.text_white}>
                                                {GetLabel(lang, 514)}
                                            </span>
                                        </div>
                                    </th>
                                    <th className={[MainStyle.align_middle].join(" ")} scope={MainStyle.col}>
                                        <div className={MainStyle.text_center}>
                                            <span className={tableFontStyle + " " + MainStyle.text_white}>
                                                {GetLabel(lang, 510)}
                                            </span>
                                        </div>
                                    </th>
                                    {/*
                                        <th className={[MainStyle.align_middle].join(" ")} scope={MainStyle.col}>
                                            <div className={MainStyle.text_center}>
                                                <span className={tableFontStyle + " " + MainStyle.text_white}>
                                                    {GetLabel(lang, 511)}
                                                </span>
                                            </div>
                                        </th>
                                    */}
                                </tr>
                            </thead>
                            <tbody>
                                {block?.Content.ANSWERS.map((item, i) => {
                                        return (tdBodyAnswers(i, item));
                                })}
                            </tbody>
                        </table>
                    </div>
                    {orderData?.OBSERVATIONS === "Y" ?
                        <React.Fragment>
                            <DefaultPadding/>
                            <div className={MainStyle.border_top}>
                                <div className={MainStyle.mt_3}>
                                    <span className={tableFontStyle + " " + MainStyle.text_black + " " + MainStyle.mx_2}>
                                        {GetLabel(lang, 512)}
                                    </span>                                
                                </div>
                                <div className={MainStyle.mb_3}>
                                    <div className={MainStyle.mx_2}>
                                        {block?.Content.ANSWERS.map((item) => {
                                                return (getObservations(item));
                                        })}
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    :
                        null
                    }
                </React.Fragment>
            )}
        </React.Fragment>
    );
});
// #endregion

// #region Question Type 4
const QType_4 = React.memo(({...other}) => {
    const { orderData, lang, fontSize, block} = other;

    useEffect(() => {}, [lang, fontSize, block]);

    function tdBodyAnswers (i, item) {
        return (
            <tr>
                <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.row}>
                    <span className={tableFontStyle + " " + MainStyle.text_black}>
                        {i + 1} - {item[`OPTION_LANG_${lang}_DESC`]}
                    </span>                    
                </th>
                <td className={[MainStyle.align_middle, MainStyle.border_end].join(" ")}>
                    <div className={MainStyle.text_black + " " + MainStyle.text_center}>
                        {item.OPTION_VALUE}
                    </div>
                </td>
                <td className={[MainStyle.align_middle, MainStyle.border_end].join(" ")}>
                    <div className={MainStyle.text_center}>
                        <span className={tableFontStyle + " " + MainStyle.text_black}>
                           {item.OCCURRENCES}
                        </span>
                    </div>
                </td>
                {countedData(block?.Content.ANSWERS)}
            </tr>
        );
    }
    function countedData(items) {
        let i = 0, t = 0, o = 0;
        let avg = 0, stdDev = 0;

        while (i < items.length) {
            t += (items[i].OPTION_VALUE * items[i].OCCURRENCES);
            o += items[i].OCCURRENCES;
            i++;
        }

        if (o > 0) {
            avg = t / o;

            let varianceSum = 0;
            for (let j = 0; j < items.length; j++) {
                let diff = items[j].OPTION_VALUE - avg;
                varianceSum += items[j].OCCURRENCES * diff * diff;
            }
            stdDev = Math.sqrt(varianceSum / o);
            stdDev = lang == "EN" ? stdDev.toFixed(1).toString() : (stdDev.toFixed(1).toString()).replaceAll('.', ',');
            avg = lang === "EN" ? avg.toFixed(1).toString() : (avg.toFixed(1).toString()).replaceAll('.', ',');
        }

        return (
            <React.Fragment>
                <td className={[MainStyle.align_middle].join(" ")}>
                    <div className={MainStyle.text_black + " " + MainStyle.text_center}>
                        {avg}
                    </div>
                </td>
                {/*
                    <td className={MainStyle.align_middle}>
                        <div className={MainStyle.text_black + " " + MainStyle.text_center}>
                            {stdDev}
                        </div>
                    </td>                
                */}
            </React.Fragment>
        );
    }
    function getObservations(item) {
        let obs = [];
        if (item.OBSERVATIONS) {
            obs = item.OBSERVATIONS.split("|n|");
        }        
        return (
            <React.Fragment>
                {item.OBSERVATIONS !== "" && (
                    <React.Fragment>
                    <div>
                        <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                            {GetLabel(lang, 513)} {item[`OPTION_LANG_${lang}_DESC`]}: 
                        </span>
                    </div>                    
                    {obs.map((item, i) => {
                        return(
                            <div className={MainStyle.text_wrap}>
                                <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                                    {i + 1} {item}
                                </span>
                            </div>
                        );
                    })}
                    </React.Fragment>
                )}
            </React.Fragment>
        );

    }
    const tableFontStyle = [MainStyle[`fs_${fontSize}`], MainStyle.fw_normal].join(" ");

    return (
        <React.Fragment>
            {block  && (
                <React.Fragment>
                    <div className={[MainStyle.table_responsive, MainStyle.rounded_top_3].join(" ")}>
                        <table className={[MainStyle.table, MainStyle.table_striped_document_export].join(" ")}>
                            <thead style={{backgroundColor: "rgb(110, 110, 110)"}}>
                                <tr>
                                    <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col} style={{ width: "35rem" }}>
                                        <div className={MainStyle.text_start}>
                                            <span className={tableFontStyle + " " + MainStyle.text_white}>
                                                {block.Header[`QUESTION_LANG_${lang}_DESC`]}
                                            </span>
                                        </div>
                                    </th>
                                    <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col}>
                                        <div className={MainStyle.text_center}>
                                            <span className={tableFontStyle + " " + MainStyle.text_white}>
                                                {GetLabel(lang, 179)}
                                            </span>
                                        </div>
                                    </th>
                                    <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col}>
                                        <div className={MainStyle.text_center}>
                                            <span className={tableFontStyle + " " + MainStyle.text_white}>
                                                {GetLabel(lang, 514)}
                                            </span>
                                        </div>
                                    </th>
                                    <th className={[MainStyle.align_middle].join(" ")} scope={MainStyle.col}>
                                        <div className={MainStyle.text_center}>
                                            <span className={tableFontStyle + " " + MainStyle.text_white}>
                                                {GetLabel(lang, 510)}
                                            </span>
                                        </div>
                                    </th>
                                    {/*
                                        <th className={[MainStyle.align_middle].join(" ")} scope={MainStyle.col}>
                                            <div className={MainStyle.text_center}>
                                                <span className={tableFontStyle + " " + MainStyle.text_white}>
                                                    {GetLabel(lang, 511)}
                                                </span>
                                            </div>
                                        </th>
                                    */}
                                </tr>
                            </thead>
                            <tbody>
                                {block?.Content.ANSWERS.map((item, i) => {
                                        return (tdBodyAnswers(i, item));
                                })}
                            </tbody>
                        </table>
                    </div>
                    {orderData?.OBSERVATIONS === "Y" ?
                        <React.Fragment>
                            <DefaultPadding/>
                            <div className={MainStyle.border_top}>
                                <div className={MainStyle.mt_3}>
                                    <span className={tableFontStyle + " " + MainStyle.text_black + " " + MainStyle.mx_2}>
                                        {GetLabel(lang, 512)}
                                    </span>                                
                                </div>
                                <div className={MainStyle.mb_3}>
                                    <div className={MainStyle.mx_2}>
                                        {block?.Content.ANSWERS.map((item) => {
                                                return (getObservations(item));
                                        })}
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    :
                        null
                    }
                </React.Fragment>
            )}
        </React.Fragment>
    );
});
// #endregion

// #region Question Type 5

const CircleShape = ({ width = 200, height = 200, setBackground, score }) => {
    const canvasRef = React.useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');

        // Set canvas dimensions
        canvas.width = width ;
        canvas.height = height;


        const gradient = context.createConicGradient(0, width / 2, height / 2);
        /* 
            addColorStop only accepts values from 0.0 <= 1.0.
            ((degree * (PI/180)) / PI) / 2
        */
        gradient.addColorStop((((0 * (Math.PI/180)) / Math.PI) / 2), '#2EAA71');
        gradient.addColorStop((((89 * (Math.PI/180)) / Math.PI) / 2), '#2EAA71');
        gradient.addColorStop((((90 * (Math.PI/180)) / Math.PI) / 2), '#E64857');
        gradient.addColorStop((((270 * (Math.PI/180)) / Math.PI) / 2), '#E64857');
        gradient.addColorStop((((271 * (Math.PI/180)) / Math.PI) / 2), '#FEB44D');
        gradient.addColorStop((((330 * (Math.PI/180)) / Math.PI) / 2), '#FEB44D');
        gradient.addColorStop((((331 * (Math.PI/180)) / Math.PI) / 2), '#2EAA71');

        // Draw a circle
        context.fillStyle = gradient; 
        context.strokeStyle = 'black';
        context.lineWidth = 0.1;

        const radius = Math.min(width, height) / 2

        context.beginPath();
        context.arc(width / 2, height / 2, radius, 0, Math.PI * 2);
        context.fill();
        context.stroke();
        
        // Convert to PNG and set background
        const dataURL = canvas.toDataURL("image/png", 1.0);
        setBackground(dataURL);
    }, [width, height, setBackground, score]);

    return (
        <canvas
            ref={canvasRef}
            style={{ display: 'none' }} // Hide the canvas
        />
    );
};
const Circle_Wrapper = ({ children, score  }) => {
      const [background, setBackground] = useState('');  

      return (
        <>
        <div
            style={{
                backgroundImage: `url(${background})`,
                backgroundRepeat: "no-repeat",
                backgroundPositionX: "center",
                backgroundPosition: "center top",
                borderRadius: "50%",
                position: 'relative', 
                width: '200px',
                height: '200px',
                margin: '20px auto', 
                borderRadius: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'visible'
            }}    
        >
          <CircleShape setBackground={setBackground} score={score}/>
          {children}
        </div>
        </>
      );
};
const NpsBlock = React.memo(({...other}) => {
    const { lang, fontSize, block } = other;
    const   p1Ref                   = React.useRef(null);
    const   p2Ref                   = React.useRef(null);
    const   pxRef                   = React.useRef(null);
    const   centerTextRef           = React.useRef(null);
    const [ npsData, setNpsData ]   = React.useState({ qt:  [0,0,0,0,0,0,0,0,0,0,0],
                                                       pr:   0,
                                                       pa:   0,
                                                       de:   0,
                                                       v:    0,
                                                       t:    0,
                                                       prq:  0,
                                                       deq:  0,
                                                       paq:  0});

    function calcScore(arr) {
        let qt   =  [0,0,0,0,0,0,0,0,0,0,0],
            pr   =  0,
            pa   =  0,
            de   =  0,
            v    =  0,
            t    =  0,
            prq  =  0,
            deq  =  0,
            paq  =  0;

        for(let i = 0; i < arr.length; i++) {
            switch (arr[i].OPTION_VALUE) {
                case 0:
                    qt[0]  += arr[i].OCCURRENCES;
                    break;
                case 1:
                    qt[1]  += arr[i].OCCURRENCES;
                    break;
                case 2:
                    qt[2]  += arr[i].OCCURRENCES;
                    break;
                case 3:
                    qt[3]  += arr[i].OCCURRENCES;
                    break;
                case 4:
                    qt[4]  += arr[i].OCCURRENCES;
                    break;
                case 5:
                    qt[5]  += arr[i].OCCURRENCES;
                    break;
                case 6:
                    qt[6]  += arr[i].OCCURRENCES;
                    break;
                case 7:
                    qt[7]  += arr[i].OCCURRENCES;
                    break;
                case 8:
                    qt[8]  += arr[i].OCCURRENCES;
                    break;
                case 9:
                    qt[9]  += arr[i].OCCURRENCES;
                    break;
                case 10:
                    qt[10]  += arr[i].OCCURRENCES;
                    break;
                default:
                    break;
            }                                                            
        }
        for(let i = 0; i < qt.length; i++) {
            t += qt[i];
        }
        if (t > 0) {
            deq = qt[0] + qt[1] + qt[2] + qt[3] + qt[4] + qt[5];
            paq = qt[6] + qt[7] + qt[8];
            prq = qt[9] + qt[10];
            pr = Math.round((prq / t) * 100);
            pa = Math.round((paq / t) * 100);
            de = Math.round((deq / t) * 100);
            v  = Math.round(pr - de);
            setNpsData((prev) => {
                return ({
                    ...prev,
                    qt:   qt,
                    pr:   pr,
                    pa:   pa,
                    de:   de,
                    v:    v,
                    t:    t,
                    prq:  prq,
                    deq:  deq,
                    paq:  paq
                });
            });
        }
    }

    function drawChart() {
        if (!p1Ref.current || !p2Ref.current || !pxRef.current || !centerTextRef.current) return;

        const R = 100;
        const h = 0.2 * 2 * R;
        const A_P1 = Math.floor(180 + Math.asin((R - h) / R) * (180 / Math.PI) - 10);
        const A_P2 = Math.floor(360 - Math.asin((R - h) / R) * (180 / Math.PI) + 10);
        
        const angleForX = (x) => {
            if (x < 0) {
                return A_P1 + ((90 - A_P1) * (x + 100)) / 100;
            } 
            else if (x === 0) {
                return 90;
            } 
            else {
                const x_0 = (90 * 100) / (A_P1 - 90);
                if (x < x_0) {
                    return 90 - (90 * x) / x_0;
                } 
                else {
                    return 360 - ((360 - A_P2) * (x - x_0)) / (100 - x_0);
                }
            }
        };

        const positionPoints = (refArray) => {
            refArray.forEach((ref, index) => {
                const angle = index === 0 ? A_P1 : A_P2;
                ref.current.style.left = `${R + R * Math.cos((Math.PI * angle) / 180)}px`;
                ref.current.style.top = `${R - R * Math.sin((Math.PI * angle) / 180)}px`;
            });
        };

        const updatePxPosition = (x) => {
            const angleDeg = angleForX(x);
            const angleRad = angleDeg * (Math.PI / 180);
            const xCoord = R + R * Math.cos(angleRad);
            const yCoord = R - R * Math.sin(angleRad);
            const px = pxRef.current;

            if (px) {
                px.style.left = `${xCoord}px`;
                px.style.top = `${yCoord}px`;
                px.style.transform = `translate(-50%, -50%) rotate(${90 - angleDeg + 180}deg)`;
                centerTextRef.current.textContent = x;
            }
        };

        const x = parseFloat(npsData.v);
        positionPoints([p1Ref, p2Ref]);
        updatePxPosition(x);
    }

    function getAvg(n, t) {
        return t > 0 ? 
                lang === "EN" ?
                    ((n / t) * 100).toFixed(1) 
                :
                    ((((n / t) * 100).toFixed(1)).toString()).replaceAll('.', ',')
            : 
                0;
    }
    
    useEffect(() => {
        if (block?.Content?.ANSWERS) {
            calcScore(block.Content.ANSWERS);
        }
    }, [block]);

    useEffect(() => {
        drawChart(); // This now runs *after* npsData is updated
    }, [npsData]);

    return (
        block && (
            <div className={MainStyle.m_3}>
                <div className={MainStyle.row}>
                    
                    <div className={MainStyle.col}>
                        <div style={{position: 'relative'}}>
                            <Circle_Wrapper score={npsData.v}>
                                <div style={{   width: '170px', height: '170px', backgroundColor: '#ffffff', borderRadius: '100%' }}>
                                    <div ref={centerTextRef} style={{ 
                                        textAlign: 'center',
                                        alignContent: 'center',
                                        marginTop: '15%',
                                        fontSize: '60px',
                                        fontWeight: '400',
                                        fontStyle: 'normal',
                                    }}/>
                                    <div className={MainStyle.text_center}>
                                        <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                                            NPS Score
                                        </span>
                                    </div>
                                </div>                            
                                <div ref={p1Ref} style={{transform: ' translate(-50%, -50%)'}}/>
                                <div ref={p2Ref} style={{transform: ' translate(-50%, -50%)'}}/>
                                <div ref={pxRef} style={{
                                        position: 'absolute',
                                        width: '0px',
                                        height: '0px',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: '2',
                                        borderLeft: '9px solid transparent',
                                        borderRight: '9px solid transparent',
                                        borderBottom: '16px solid black',                                
                                }}/>
                            </Circle_Wrapper>
                            <div style={{ width: '100%', height: '3.0rem', backgroundColor: '#ffffff', position: 'absolute', marginTop: '-3.9rem'}}>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_2}></div>
                                    <div className={MainStyle.col_8}>
                                    <div className={MainStyle.row}>
                                        <div className={[MainStyle.col_4, MainStyle.text_end, MainStyle.py_1].join(" ")}>
                                        <span className={MainStyle.px_4}>
                                            -100
                                        </span>
                                        </div>
                                        <div className={[MainStyle.col_4, MainStyle.text_center, MainStyle.py_1].join(" ")}>
                                        <span>
                                            0
                                        </span>
                                        </div>
                                        <div className={[MainStyle.col_4, MainStyle.text_start, MainStyle.py_1].join(" ")}>
                                        <span className={MainStyle.px_4}>
                                            100
                                        </span>
                                        </div>
                                    </div>
                                    </div>
                                    <div className={MainStyle.col_2}></div>                                                  
                                </div>
                            </div>
                        </div>                        
                    </div>

                    <div className={MainStyle.col}>
                        <div className={MainStyle.overflow_x_scroll}>

                            <div className={[MainStyle.d_flex, MainStyle.justify_content_between,].join(" ")}>

                        
                                <div className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                    <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{npsData.qt[0]}</span>                                    
                                    <div style={{width: '4rem', height: '3rem', backgroundColor: 'rgb(177, 24, 32)'}} className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>0</span>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{`(${getAvg(npsData.qt[0],npsData.t)}%)`}</span>
                                    </div>                                
                                </div>                        
                            
                                <div className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                    <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{npsData.qt[1]}</span>
                                    <div style={{width: '4rem', height: '3rem', backgroundColor: 'rgb(213,24,32)'}} className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>1</span>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{`(${getAvg(npsData.qt[1],npsData.t)}%)`}</span>
                                    </div>
                                </div>
                            
                                <div className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                    <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{npsData.qt[2]}</span>
                                    <div style={{width: '4rem', height: '3rem', backgroundColor: 'rgb(239,64,36)'}} className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>2</span>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{`(${getAvg(npsData.qt[2],npsData.t)}%)`}</span>
                                    </div>
                                </div>                            
                            
                                <div className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                    <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{npsData.qt[3]}</span>
                                    <div style={{width: '4rem', height: '3rem', backgroundColor: 'rgb(244,102,34)'}} className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>3</span>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{`(${getAvg(npsData.qt[3],npsData.t)}%)`}</span>
                                    </div>                                    
                                </div>
                            
                                <div className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                    <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{npsData.qt[4]}</span>
                                    <div style={{width: '4rem', height: '3rem', backgroundColor: 'rgb(247,141,32)'}} className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>4</span>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{`(${getAvg(npsData.qt[4],npsData.t)}%)`}</span>
                                    </div>
                                </div>
                            
                                <div className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                    <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{npsData.qt[5]}</span>
                                    <div style={{width: '4rem', height: '3rem', backgroundColor: 'rgb(254,175,24)'}} className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>5</span>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{`(${getAvg(npsData.qt[5],npsData.t)}%)`}</span>
                                    </div>
                                </div>                                                    

                                <div className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                    <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{npsData.qt[6]}</span>
                                    <div style={{width: '4rem', height: '3rem', backgroundColor: 'rgb(255,215,0)'}} className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>6</span>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{`(${getAvg(npsData.qt[6],npsData.t)}%)`}</span>
                                    </div>
                                </div>
                            
                                <div className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                    <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{npsData.qt[7]}</span>
                                    <div style={{width: '4rem', height: '3rem', backgroundColor: 'rgb(120,126,131)'}} className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>7</span>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{`(${getAvg(npsData.qt[7],npsData.t)}%)`}</span>
                                    </div>
                                </div>
                            
                                <div className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                    <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{npsData.qt[8]}</span>
                                    <div style={{width: '4rem', height: '3rem', backgroundColor: 'rgb(227,230,233)'}} className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>8</span>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{`(${getAvg(npsData.qt[8],npsData.t)}%)`}</span>
                                    </div>
                                </div>                            
                            
                                <div className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                    <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{npsData.qt[9]}</span>                                
                                    <div style={{width: '4rem', height: '3rem', backgroundColor: 'rgb(135,197,70)'}} className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>9</span>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{`(${getAvg(npsData.qt[9],npsData.t)}%)`}</span>
                                    </div>
                                </div>
                            
                                <div className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                    <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{npsData.qt[10]}</span>
                                    <div style={{width: '4rem', height: '3rem', backgroundColor: 'rgb(72, 163, 62)'}} className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center].join(" ")}>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>10</span>
                                        <span style={{color: 'rgb(0,0,0)'}} className={[MainStyle[`fs_${fontSize}`]].join(" ")}>{`(${getAvg(npsData.qt[10],npsData.t)}%)`}</span>
                                    </div>                                    
                                </div>



                            </div>

                            <div className={[MainStyle.d_flex, MainStyle.justify_content_between,].join(" ")}>
                                
                                
                                <div className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center,  MainStyle.mx_5].join(" ")}>
                                    <svg viewBox="0 0 608 608" style={{width: `5.0rem`, height: `5.0rem`}}>

                                        <path style={{fill: "rgb(213,24,32)"}} 	d=" M353.671753,382.207947 
                                                                            C344.291962,382.316345 344.286438,382.316345 344.285492,391.218353 
                                                                            C344.281799,425.873718 344.296814,460.529083 344.270721,495.184448 
                                                                            C344.263763,504.446136 340.664215,511.623505 332.006348,515.787842 
                                                                            C329.537994,516.975159 326.969910,517.378174 324.258240,517.371521 
                                                                            C313.262024,517.344421 302.265503,517.417053 291.269348,517.379517 
                                                                            C278.103882,517.334595 269.696198,508.993011 269.681427,495.874115 
                                                                            C269.642487,461.218781 269.666351,426.563354 269.663513,391.907990 
                                                                            C269.663391,390.408569 269.636017,388.909088 269.638885,387.409698 
                                                                            C269.645416,383.953430 268.099915,382.107941 264.471497,382.263367 
                                                                            C262.642548,382.341736 260.803497,382.330139 258.974640,382.242188 
                                                                            C245.660263,381.601959 236.695068,372.288605 236.671127,358.960388 
                                                                            C236.604980,322.139404 236.556946,285.318329 236.565048,248.497284 
                                                                            C236.568375,233.392181 245.589493,224.081558 260.751984,223.996857 
                                                                            C290.574585,223.830231 320.399292,223.847809 350.222107,223.994553 
                                                                            C365.304871,224.068756 374.261230,232.387283 374.468628,247.769241 
                                                                            C374.960480,284.245331 374.850494,320.730499 374.837402,357.211945 
                                                                            C374.832977,369.574646 369.604156,379.757690 353.671753,382.207947 z"
                                        />
                                        <path style={{fill: "rgb(254,175,24)"}} 	d="M447.241211,226.039856 
                                                                        C456.652008,229.301651 461.187378,235.403168 461.208405,244.905838 
                                                                        C461.274353,274.737030 461.287659,304.568542 461.231232,334.399750 
                                                                        C461.208679,346.323700 453.940826,353.994843 442.080261,354.142029 
                                                                        C437.286377,354.201508 436.215759,356.008118 436.237305,360.381592 
                                                                        C436.375275,388.378998 436.301971,416.377472 436.289856,444.375580 
                                                                        C436.284027,457.823608 429.810455,464.328949 416.438232,464.340302 
                                                                        C408.605438,464.346985 400.772339,464.382385 392.939880,464.330078 
                                                                        C382.977814,464.263519 376.458038,458.753967 375.469910,448.841705 
                                                                        C374.827728,442.399628 375.056488,435.863159 375.033325,429.368500 
                                                                        C374.985748,416.036255 375.096985,402.703217 374.991699,389.371674 
                                                                        C374.965393,386.036652 375.728546,383.291046 377.960114,380.701630 
                                                                        C383.395081,374.395111 385.758728,366.968994 385.742432,358.614899 
                                                                        C385.670593,321.784180 385.631561,284.952820 385.794037,248.122665 
                                                                        C385.829071,240.178864 383.332886,233.178299 379.061035,225.917252 
                                                                        C402.098419,225.917252 424.463043,225.917252 447.241211,226.039856 z"
                                        />
                                        <path style={{fill: "rgb(244,101,33)"}} 	d="M150.726974,284.999939 
                                                                        C150.725067,271.501831 150.682373,258.503571 150.733826,245.505676 
                                                                        C150.785172,232.534836 158.002487,225.537994 170.960587,225.574615 
                                                                        C189.113068,225.625900 207.265869,225.558395 225.418503,225.574509 
                                                                        C227.373199,225.576248 229.407715,225.172012 231.226746,226.228485 
                                                                        C231.325806,226.607544 231.576614,227.020844 231.461380,227.204742 
                                                                        C225.709030,236.383179 225.173798,246.528275 225.246017,257.014343 
                                                                        C225.475555,290.341248 225.393875,323.670898 225.295258,356.999084 
                                                                        C225.264053,367.545258 228.591461,376.610046 236.148315,383.979828 
                                                                        C237.855377,385.644623 238.561951,387.373932 238.551941,389.695129 
                                                                        C238.467911,409.178101 238.567917,428.662689 238.358383,448.144043 
                                                                        C238.260559,457.240112 231.147110,464.124390 221.999588,464.292389 
                                                                        C213.170517,464.454529 204.335907,464.375702 195.504242,464.321808 
                                                                        C184.704041,464.255920 177.723114,457.289276 177.701050,446.423706 
                                                                        C177.644531,418.594543 177.672913,390.765198 177.664124,362.935944 
                                                                        C177.661484,354.539001 177.656662,354.539001 169.496109,354.241913 
                                                                        C158.401672,353.838013 150.850815,346.245972 150.759659,334.992157 
                                                                        C150.626022,318.495728 150.726639,301.997467 150.726974,284.999939 z"
                                        />
                                        <path style={{fill: "rgb(213,24,32)"}} 	d="M268.709686,136.777847 
                                                                        C281.438049,120.608070 302.527100,114.569054 321.439545,121.438080 
                                                                        C340.665222,128.420868 353.254456,146.669083 352.108124,167.116806 
                                                                        C350.700500,192.225601 332.598328,208.955963 311.345184,211.199234 
                                                                        C282.250732,214.270172 263.502045,194.341248 259.947693,173.453018 
                                                                        C257.709473,160.299561 260.372070,147.957916 268.709686,136.777847 z"
                                        />
                                        <path style={{fill: "rgb(254,175,24)"}} 	d="M378.846252,205.176147 
                                                                        C368.175110,194.330307 364.360321,181.738113 368.217316,167.369247
                                                                        C372.154358,152.702209 382.067780,143.795868 396.763916,140.282410 
                                                                        C411.327850,136.800537 427.491241,143.318207 436.154358,155.993195 
                                                                        C444.817810,168.668579 444.771851,185.864304 436.039917,198.822983 
                                                                        C427.573517,211.387589 411.843475,217.623398 397.171600,214.485260 
                                                                        C390.308716,213.017334 384.277679,210.141647 378.846252,205.176147 z"
                                        />
                                        <path style={{fill: "rgb(244,101,33)"}} 	d="M186.586197,145.450500 
                                                                        C212.631302,130.631546 242.227875,145.656631 245.127228,174.809189 
                                                                        C246.487961,188.491135 237.582932,204.603790 225.181046,210.899567 
                                                                        C211.211868,217.990982 194.589020,216.163589 183.340637,207.043396 
                                                                        C163.699707,191.118469 164.858749,159.428452 186.586197,145.450500 z"
                                        />                                
                                    
                                    
                                    </svg>
                                    <span className={[MainStyle[`fs_${fontSize}`], MainStyle.fw_semibold].join(" ")}>{GetLabel(lang, 515)}</span>
                                    <span className={[MainStyle[`fs_${fontSize}`], MainStyle.fw_semibold].join(" ")}>{`${npsData.deq} (${npsData.de}%)`}</span>
                                </div>

                                <div className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center,  MainStyle.mx_5].join(" ")}>
                                    <svg viewBox="0 0 608 608" style={{width: `5.0rem`, height: `5.0rem`}}>

                                        <path style={{fill: "rgb(199,201,203)"}} 	d=" M353.671753,382.207947 
                                                                            C344.291962,382.316345 344.286438,382.316345 344.285492,391.218353 
                                                                            C344.281799,425.873718 344.296814,460.529083 344.270721,495.184448 
                                                                            C344.263763,504.446136 340.664215,511.623505 332.006348,515.787842 
                                                                            C329.537994,516.975159 326.969910,517.378174 324.258240,517.371521 
                                                                            C313.262024,517.344421 302.265503,517.417053 291.269348,517.379517 
                                                                            C278.103882,517.334595 269.696198,508.993011 269.681427,495.874115 
                                                                            C269.642487,461.218781 269.666351,426.563354 269.663513,391.907990 
                                                                            C269.663391,390.408569 269.636017,388.909088 269.638885,387.409698 
                                                                            C269.645416,383.953430 268.099915,382.107941 264.471497,382.263367 
                                                                            C262.642548,382.341736 260.803497,382.330139 258.974640,382.242188 
                                                                            C245.660263,381.601959 236.695068,372.288605 236.671127,358.960388 
                                                                            C236.604980,322.139404 236.556946,285.318329 236.565048,248.497284 
                                                                            C236.568375,233.392181 245.589493,224.081558 260.751984,223.996857 
                                                                            C290.574585,223.830231 320.399292,223.847809 350.222107,223.994553 
                                                                            C365.304871,224.068756 374.261230,232.387283 374.468628,247.769241 
                                                                            C374.960480,284.245331 374.850494,320.730499 374.837402,357.211945 
                                                                            C374.832977,369.574646 369.604156,379.757690 353.671753,382.207947 z"
                                        />
                                        <path style={{fill: "rgb(179,187,191)"}} 	d="M447.241211,226.039856 
                                                                        C456.652008,229.301651 461.187378,235.403168 461.208405,244.905838 
                                                                        C461.274353,274.737030 461.287659,304.568542 461.231232,334.399750 
                                                                        C461.208679,346.323700 453.940826,353.994843 442.080261,354.142029 
                                                                        C437.286377,354.201508 436.215759,356.008118 436.237305,360.381592 
                                                                        C436.375275,388.378998 436.301971,416.377472 436.289856,444.375580 
                                                                        C436.284027,457.823608 429.810455,464.328949 416.438232,464.340302 
                                                                        C408.605438,464.346985 400.772339,464.382385 392.939880,464.330078 
                                                                        C382.977814,464.263519 376.458038,458.753967 375.469910,448.841705 
                                                                        C374.827728,442.399628 375.056488,435.863159 375.033325,429.368500 
                                                                        C374.985748,416.036255 375.096985,402.703217 374.991699,389.371674 
                                                                        C374.965393,386.036652 375.728546,383.291046 377.960114,380.701630 
                                                                        C383.395081,374.395111 385.758728,366.968994 385.742432,358.614899 
                                                                        C385.670593,321.784180 385.631561,284.952820 385.794037,248.122665 
                                                                        C385.829071,240.178864 383.332886,233.178299 379.061035,225.917252 
                                                                        C402.098419,225.917252 424.463043,225.917252 447.241211,226.039856 z"
                                        />
                                        <path style={{fill: "rgb(120,126,131)"}} 	d="M150.726974,284.999939 
                                                                        C150.725067,271.501831 150.682373,258.503571 150.733826,245.505676 
                                                                        C150.785172,232.534836 158.002487,225.537994 170.960587,225.574615 
                                                                        C189.113068,225.625900 207.265869,225.558395 225.418503,225.574509 
                                                                        C227.373199,225.576248 229.407715,225.172012 231.226746,226.228485 
                                                                        C231.325806,226.607544 231.576614,227.020844 231.461380,227.204742 
                                                                        C225.709030,236.383179 225.173798,246.528275 225.246017,257.014343 
                                                                        C225.475555,290.341248 225.393875,323.670898 225.295258,356.999084 
                                                                        C225.264053,367.545258 228.591461,376.610046 236.148315,383.979828 
                                                                        C237.855377,385.644623 238.561951,387.373932 238.551941,389.695129 
                                                                        C238.467911,409.178101 238.567917,428.662689 238.358383,448.144043 
                                                                        C238.260559,457.240112 231.147110,464.124390 221.999588,464.292389 
                                                                        C213.170517,464.454529 204.335907,464.375702 195.504242,464.321808 
                                                                        C184.704041,464.255920 177.723114,457.289276 177.701050,446.423706 
                                                                        C177.644531,418.594543 177.672913,390.765198 177.664124,362.935944 
                                                                        C177.661484,354.539001 177.656662,354.539001 169.496109,354.241913 
                                                                        C158.401672,353.838013 150.850815,346.245972 150.759659,334.992157 
                                                                        C150.626022,318.495728 150.726639,301.997467 150.726974,284.999939 z"
                                        />
                                        <path style={{fill: "rgb(199,201,203)"}} 	d="M268.709686,136.777847 
                                                                        C281.438049,120.608070 302.527100,114.569054 321.439545,121.438080 
                                                                        C340.665222,128.420868 353.254456,146.669083 352.108124,167.116806 
                                                                        C350.700500,192.225601 332.598328,208.955963 311.345184,211.199234 
                                                                        C282.250732,214.270172 263.502045,194.341248 259.947693,173.453018 
                                                                        C257.709473,160.299561 260.372070,147.957916 268.709686,136.777847 z"
                                        />
                                        <path style={{fill: "rgb(179,187,191)"}} 	d="M378.846252,205.176147 
                                                                        C368.175110,194.330307 364.360321,181.738113 368.217316,167.369247
                                                                        C372.154358,152.702209 382.067780,143.795868 396.763916,140.282410 
                                                                        C411.327850,136.800537 427.491241,143.318207 436.154358,155.993195 
                                                                        C444.817810,168.668579 444.771851,185.864304 436.039917,198.822983 
                                                                        C427.573517,211.387589 411.843475,217.623398 397.171600,214.485260 
                                                                        C390.308716,213.017334 384.277679,210.141647 378.846252,205.176147 z"
                                        />
                                        <path style={{fill: "rgb(120,126,131)"}} 	d="M186.586197,145.450500 
                                                                        C212.631302,130.631546 242.227875,145.656631 245.127228,174.809189 
                                                                        C246.487961,188.491135 237.582932,204.603790 225.181046,210.899567 
                                                                        C211.211868,217.990982 194.589020,216.163589 183.340637,207.043396 
                                                                        C163.699707,191.118469 164.858749,159.428452 186.586197,145.450500 z"
                                        />                                
                                    
                                    
                                    </svg>
                                    <span className={[MainStyle[`fs_${fontSize}`], MainStyle.fw_semibold].join(" ")}>{GetLabel(lang, 516)}</span>
                                    <span className={[MainStyle[`fs_${fontSize}`], MainStyle.fw_semibold].join(" ")}>{`${npsData.paq} (${npsData.pa}%)`}</span>
                                </div>

                                <div className={[MainStyle.d_flex, MainStyle.flex_column, MainStyle.align_items_center, MainStyle.mx_5].join(" ")}>
                                    <svg viewBox="0 0 608 608" style={{width: `5.0rem`, height: `5.0rem`}}>

                                        <path style={{fill: "rgb(68,163,62)"}} 	d=" M353.671753,382.207947 
                                                                            C344.291962,382.316345 344.286438,382.316345 344.285492,391.218353 
                                                                            C344.281799,425.873718 344.296814,460.529083 344.270721,495.184448 
                                                                            C344.263763,504.446136 340.664215,511.623505 332.006348,515.787842 
                                                                            C329.537994,516.975159 326.969910,517.378174 324.258240,517.371521 
                                                                            C313.262024,517.344421 302.265503,517.417053 291.269348,517.379517 
                                                                            C278.103882,517.334595 269.696198,508.993011 269.681427,495.874115 
                                                                            C269.642487,461.218781 269.666351,426.563354 269.663513,391.907990 
                                                                            C269.663391,390.408569 269.636017,388.909088 269.638885,387.409698 
                                                                            C269.645416,383.953430 268.099915,382.107941 264.471497,382.263367 
                                                                            C262.642548,382.341736 260.803497,382.330139 258.974640,382.242188 
                                                                            C245.660263,381.601959 236.695068,372.288605 236.671127,358.960388 
                                                                            C236.604980,322.139404 236.556946,285.318329 236.565048,248.497284 
                                                                            C236.568375,233.392181 245.589493,224.081558 260.751984,223.996857 
                                                                            C290.574585,223.830231 320.399292,223.847809 350.222107,223.994553 
                                                                            C365.304871,224.068756 374.261230,232.387283 374.468628,247.769241 
                                                                            C374.960480,284.245331 374.850494,320.730499 374.837402,357.211945 
                                                                            C374.832977,369.574646 369.604156,379.757690 353.671753,382.207947 z"
                                        />
                                        <path style={{fill: "rgb(211,225,86)"}} 	d="M447.241211,226.039856 
                                                                        C456.652008,229.301651 461.187378,235.403168 461.208405,244.905838 
                                                                        C461.274353,274.737030 461.287659,304.568542 461.231232,334.399750 
                                                                        C461.208679,346.323700 453.940826,353.994843 442.080261,354.142029 
                                                                        C437.286377,354.201508 436.215759,356.008118 436.237305,360.381592 
                                                                        C436.375275,388.378998 436.301971,416.377472 436.289856,444.375580 
                                                                        C436.284027,457.823608 429.810455,464.328949 416.438232,464.340302 
                                                                        C408.605438,464.346985 400.772339,464.382385 392.939880,464.330078 
                                                                        C382.977814,464.263519 376.458038,458.753967 375.469910,448.841705 
                                                                        C374.827728,442.399628 375.056488,435.863159 375.033325,429.368500 
                                                                        C374.985748,416.036255 375.096985,402.703217 374.991699,389.371674 
                                                                        C374.965393,386.036652 375.728546,383.291046 377.960114,380.701630 
                                                                        C383.395081,374.395111 385.758728,366.968994 385.742432,358.614899 
                                                                        C385.670593,321.784180 385.631561,284.952820 385.794037,248.122665 
                                                                        C385.829071,240.178864 383.332886,233.178299 379.061035,225.917252 
                                                                        C402.098419,225.917252 424.463043,225.917252 447.241211,226.039856 z"
                                        />
                                        <path style={{fill: "rgb(135,197,72)"}} 	d="M150.726974,284.999939 
                                                                        C150.725067,271.501831 150.682373,258.503571 150.733826,245.505676 
                                                                        C150.785172,232.534836 158.002487,225.537994 170.960587,225.574615 
                                                                        C189.113068,225.625900 207.265869,225.558395 225.418503,225.574509 
                                                                        C227.373199,225.576248 229.407715,225.172012 231.226746,226.228485 
                                                                        C231.325806,226.607544 231.576614,227.020844 231.461380,227.204742 
                                                                        C225.709030,236.383179 225.173798,246.528275 225.246017,257.014343 
                                                                        C225.475555,290.341248 225.393875,323.670898 225.295258,356.999084 
                                                                        C225.264053,367.545258 228.591461,376.610046 236.148315,383.979828 
                                                                        C237.855377,385.644623 238.561951,387.373932 238.551941,389.695129 
                                                                        C238.467911,409.178101 238.567917,428.662689 238.358383,448.144043 
                                                                        C238.260559,457.240112 231.147110,464.124390 221.999588,464.292389 
                                                                        C213.170517,464.454529 204.335907,464.375702 195.504242,464.321808 
                                                                        C184.704041,464.255920 177.723114,457.289276 177.701050,446.423706 
                                                                        C177.644531,418.594543 177.672913,390.765198 177.664124,362.935944 
                                                                        C177.661484,354.539001 177.656662,354.539001 169.496109,354.241913 
                                                                        C158.401672,353.838013 150.850815,346.245972 150.759659,334.992157 
                                                                        C150.626022,318.495728 150.726639,301.997467 150.726974,284.999939 z"
                                        />
                                        <path style={{fill: "rgb(68,163,62)"}} 	d="M268.709686,136.777847 
                                                                        C281.438049,120.608070 302.527100,114.569054 321.439545,121.438080 
                                                                        C340.665222,128.420868 353.254456,146.669083 352.108124,167.116806 
                                                                        C350.700500,192.225601 332.598328,208.955963 311.345184,211.199234 
                                                                        C282.250732,214.270172 263.502045,194.341248 259.947693,173.453018 
                                                                        C257.709473,160.299561 260.372070,147.957916 268.709686,136.777847 z"
                                        />
                                        <path style={{fill: "rgb(211,225,86)"}} 	d="M378.846252,205.176147 
                                                                        C368.175110,194.330307 364.360321,181.738113 368.217316,167.369247
                                                                        C372.154358,152.702209 382.067780,143.795868 396.763916,140.282410 
                                                                        C411.327850,136.800537 427.491241,143.318207 436.154358,155.993195 
                                                                        C444.817810,168.668579 444.771851,185.864304 436.039917,198.822983 
                                                                        C427.573517,211.387589 411.843475,217.623398 397.171600,214.485260 
                                                                        C390.308716,213.017334 384.277679,210.141647 378.846252,205.176147 z"
                                        />
                                        <path style={{fill: "rgb(68,163,62)"}} 	d="M186.586197,145.450500 
                                                                        C212.631302,130.631546 242.227875,145.656631 245.127228,174.809189 
                                                                        C246.487961,188.491135 237.582932,204.603790 225.181046,210.899567 
                                                                        C211.211868,217.990982 194.589020,216.163589 183.340637,207.043396 
                                                                        C163.699707,191.118469 164.858749,159.428452 186.586197,145.450500 z"
                                        />
                                    </svg>
                                    <span className={[MainStyle[`fs_${fontSize}`], MainStyle.fw_semibold].join(" ")}>{GetLabel(lang, 517)}</span>
                                    <span className={[MainStyle[`fs_${fontSize}`], MainStyle.fw_semibold].join(" ")}>{`${npsData.prq} (${npsData.pr}%)`}</span>
                                </div>                            


                            </div>

                            <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.my_3].join(" ")}>
                                <span className={[MainStyle[`fs_${fontSize - 1}`], MainStyle.fw_semibold].join(" ")}>{`NPS = ${GetLabel(lang, 517)} (${npsData.pr}%) - ${GetLabel(lang, 515)} (${npsData.de}%)`}</span>
                            </div>
                            
                        </div>


                    </div>

                </div>
            </div>
        )
    );

});
const QType_5 = React.memo(({...other}) => {
    const { orderData, lang, fontSize, block} = other;
    const fontStyle         = [MainStyle[`fs_${fontSize}`], MainStyle.fw_normal].join(" ");
    
    function getObservations(item) {
        let obs = [];
        if (item.OBSERVATIONS) {
            obs = item.OBSERVATIONS.split("|n|");
        }        
        return (
            <React.Fragment>
                {item.OBSERVATIONS !== "" && (
                    <React.Fragment>
                    <div>
                        <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                            {GetLabel(lang, 513)} {item[`OPTION_LANG_${lang}_DESC`]}: 
                        </span>
                    </div>                    
                    {obs.map((item, i) => {
                        return(
                            <div className={MainStyle.text_wrap}>
                                <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                                    {i + 1} {item}
                                </span>
                            </div>
                        );
                    })}
                    </React.Fragment>
                )}
            </React.Fragment>
        );

    }
    useEffect(() => {}, [lang, fontSize, block]);


    return (
        <React.Fragment>
            {block  && (
                <React.Fragment>
                    <div className={[MainStyle.row, MainStyle.rounded_5].join(" ")} style={{backgroundColor: "rgb(110, 110, 110)"}}>
                        <div className={MainStyle.col}>
                            <div className={MainStyle.m_2}>
                                <span className={[MainStyle[`fs_${fontSize}`], MainStyle.fw_normal, MainStyle.text_white].join(" ")}>
                                    {`${block.Header.PREFIX}`} {block.Header[`QUESTION_LANG_${lang}_DESC`]}
                                </span>
                            </div>
                        </div>
                    </div>
                    <NpsBlock lang={lang} fontSize={fontSize} block={block}/>
                    {orderData?.OBSERVATIONS === "Y" ?
                        <React.Fragment>
                            <DefaultPadding/>
                            <div className={MainStyle.border_top}>
                                <div className={MainStyle.mt_3}>
                                    <span className={fontStyle + " " + MainStyle.mx_2}>
                                        {GetLabel(lang, 512)}
                                    </span>                                
                                </div>
                                <div className={MainStyle.mb_3}>
                                    <div className={MainStyle.mx_2}>
                                        {block?.Content.ANSWERS.map((item) => {
                                                return (getObservations(item));
                                        })}
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    :
                        null
                    }
                </React.Fragment>
            )}
        </React.Fragment>
    );

});
// #endregion

// #region Question Type 6
const QType_6 = React.memo(({...other}) => {
    const { orderData, lang, fontSize, block} = other;

    useEffect(() => {

    }, [lang, fontSize, block]);

    function tHeadStar (d) {
        return (
            <React.Fragment>
                <div className={[MainStyle.d_flex, MainStyle.align_middle].join("")}>
                    <span className={[MainStyle[`fs_${fontSize}`], MainStyle.text_white].join(" ")}>
                        {d}
                    </span>
                    <svg viewBox="0 0 576 512" style={{width: `1.0rem`, height: `1.0rem`}}>
                        <path style={{fill: "#fff"}} d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/>
                    </svg>
                </div>
            </React.Fragment>
        );
    }
    function tdBodyAnswers (item) {
        return (
            <React.Fragment>
                <td className={[MainStyle.align_middle, MainStyle.border_end].join(" ")}>
                    <div className={MainStyle.text_black + " " + MainStyle.text_center}>
                        {item.OCCURRENCES}
                    </div>
                </td>
            </React.Fragment>
        );
    }
    function countedData(items) {
        let i = 0, t = 0, o = 0;
        let avg = 0, stdDev = 0;

        while (i < items.length) {            
            t += (items[i].OPTION_VALUE * items[i].OCCURRENCES);
            o += items[i].OCCURRENCES;
            i++;
        }

        if (o > 0) {
            avg = t / o;

            let varianceSum = 0;
            for (let j = 0; j < items.length; j++) {
                let diff = items[j].OPTION_VALUE - avg;
                varianceSum += items[j].OCCURRENCES * diff * diff;
            }
            stdDev = Math.sqrt(varianceSum / o);
            stdDev = lang == "EN" ? stdDev.toFixed(1).toString() : (stdDev.toFixed(1).toString()).replaceAll('.', ',');
            avg = lang === "EN" ? avg.toFixed(1).toString() : (avg.toFixed(1).toString()).replaceAll('.', ',');            
        }

        return (
            <React.Fragment>
                <td className={[MainStyle.align_middle].join(" ")}>
                    <div className={MainStyle.text_black + " " + MainStyle.text_center}>
                        {avg}
                    </div>
                </td>
                {/*
                    <td className={MainStyle.align_middle}>
                        <div className={MainStyle.text_black + " " + MainStyle.text_center}>
                            {stdDev}
                        </div>
                    </td>                
                */}
            </React.Fragment>
        );
    }
    function questionRow(q) {
        return (
            <tr>
                <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.row}>
                    <span className={tableFontStyle + " " + MainStyle.text_black}>
                        {q.PREFIX} {q[`QUESTION_LANG_${lang}_DESC`]}
                    </span>                    
                </th>
                {q?.ANSWERS.map((item) => {
                        return (tdBodyAnswers(item));
                })}
                {countedData(q?.ANSWERS)}
            </tr>
        );
    }
    function getObservations(item) {
        let obs = [];
        if (item.OBSERVATIONS) {
            obs = item.OBSERVATIONS.split("|n|");
        }        
        return (
            <React.Fragment>
                {item.OBSERVATIONS !== "" && (
                    <React.Fragment>
                    <div>
                        <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                            {GetLabel(lang, 513)} {item[`OPTION_LANG_${lang}_DESC`]}: 
                        </span>
                    </div>                    
                    {obs.map((item, i) => {
                        return(
                            <div className={MainStyle.text_wrap}>
                                <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                                    {i + 1} {item}
                                </span>
                            </div>
                        );
                    })}
                    </React.Fragment>
                )}
            </React.Fragment>
        );

    }
    const tableFontStyle = [MainStyle[`fs_${fontSize}`], MainStyle.fw_normal].join(" ");

    return (
        <React.Fragment>
            {block  && (
                block?.Content.length > 0 ?
                <React.Fragment>
                    <div className={[MainStyle.table_responsive, MainStyle.rounded_top_3].join(" ")}>
                        <table className={[MainStyle.table, MainStyle.table_striped_document_export].join(" ")}>
                            <thead style={{backgroundColor: "rgb(110, 110, 110)"}}>
                                <tr>
                                    <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col} style={{ width: "30rem" }}>
                                        <div className={MainStyle.text_start}>
                                            <span className={[MainStyle[`fs_${fontSize}`], MainStyle.fw_semibold, MainStyle.text_white].join(" ")}>
                                                {block.PREFIX} {block.Header[`QUESTION_LANG_${lang}_DESC`]}
                                            </span>
                                        </div>
                                    </th>
                                    <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col}>
                                        <div className={MainStyle.text_center}>
                                            {tHeadStar(1)}
                                        </div>
                                    </th>
                                    <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col}>
                                        <div className={MainStyle.text_center}>
                                            {tHeadStar(2)}
                                        </div>
                                    </th>
                                    <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col}>
                                        <div className={MainStyle.text_center}>
                                            {tHeadStar(3)}
                                        </div>
                                    </th>
                                    <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col}>
                                        <div className={MainStyle.text_center}>
                                            {tHeadStar(4)}
                                        </div>
                                    </th>
                                    <th className={[MainStyle.align_middle, MainStyle.border_end].join(" ")} scope={MainStyle.col}>
                                        <div className={MainStyle.text_center}>
                                            {tHeadStar(5)}
                                        </div>
                                    </th>
                                    <th className={[MainStyle.align_middle].join(" ")} scope={MainStyle.col}>
                                        <div className={MainStyle.text_center}>
                                            <span className={tableFontStyle + " " + MainStyle.text_white}>
                                                {GetLabel(lang, 510)}
                                            </span>
                                        </div>
                                    </th>
                                    {/*
                                        <th className={[MainStyle.align_middle].join(" ")} scope={MainStyle.col}>
                                            <div className={MainStyle.text_center}>
                                                <span className={tableFontStyle + " " + MainStyle.text_white}>
                                                    {GetLabel(lang, 511)}
                                                </span>
                                            </div>
                                        </th>                                    
                                    */}
                                </tr>
                            </thead>
                            <tbody>
                                {block.Content.map((question) => {
                                    return(
                                        questionRow(question)
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    {orderData?.OBSERVATIONS === "Y" ?
                        <React.Fragment>
                            <DefaultPadding/>
                            <div className={MainStyle.border_top}>
                                <div className={MainStyle.mt_3}>
                                    <span className={tableFontStyle  + " " + MainStyle.text_black + " " +  MainStyle.mx_2}>
                                        {GetLabel(lang, 512)}
                                    </span>                                
                                </div>
                                <div className={MainStyle.mb_3}>
                                    <div className={MainStyle.mx_2}>
                                        {block?.Content.map((question, i) => {
                                            return(
                                                <React.Fragment>
                                                    <div>
                                                        <span className={tableFontStyle  + " " + MainStyle.text_black}>
                                                            {i + 1} - {question[`QUESTION_LANG_${lang}_DESC`]}
                                                        </span>
                                                    </div>
                                                    <div className={MainStyle.mx_2}>
                                                        {question?.ANSWERS.map((answer) => {
                                                            return(
                                                                getObservations(answer)
                                                            )
                                                        })}
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })}
                                        {
                                        //getObservations(question)
                                        }
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    :
                        null
                    }
                </React.Fragment>
                :
                    <div className={MainStyle.text_start}>
                        <span className={[MainStyle[`fs_${fontSize - 3 }`], MainStyle.fw_semibold].join(" ")}>
                            {block.PREFIX} {block.Header[`QUESTION_LANG_${lang}_DESC`]}
                        </span>
                    </div>
            )}
        </React.Fragment>
    );

});
// #endregion

// #region Sessions
const SessionBlock = React.memo(({...other}) => {
    const { orderData,
            data,
            lang,
            fontSize                 } = other;

    const [ firstHalf,   setFirstHalf ]      = useState(null);
    const [ secondHalf,  setSecondHalf]      = useState(null);
    const [ dataSet,     setDataSet  ]       = useState([]);

    useEffect(() => {
        if (data?.SESSION_LINES) {
            const middle = Math.ceil(data.SESSION_LINES.length / 2);
            setFirstHalf(data.SESSION_LINES.slice(0, middle));
            setSecondHalf(data.SESSION_LINES.slice(middle));
        }
        function blankContent()  {
            return ({
                Type: 0, 
                Position: 0, 
                Header: {}, 
                Content: []
            });
        }
        /*
        const parseData = async () => {
            if (data?.QUESTIONS) {
                let contentData = null;
                let mainData = [];
                let dispatch    = true;
                
                for(let i = 0; i < data?.QUESTIONS.length; i++) {               
                    
                    if (data.QUESTIONS[i].QUESTION_TYPE_ID === 6) {
                        if (contentData === null) {
                            contentData = blankContent();
                            contentData.Type = 6;
                            contentData.Position = data.QUESTIONS[i].QUESTION_POSITION;
                            contentData.Header = data.QUESTIONS[i];
                            dispatch    = false;
                        }
                        else if (contentData !== null) {
                            mainData.push(contentData);
                            contentData = blankContent();
                            contentData.Type = 6;
                            contentData.Position = data.QUESTIONS[i].QUESTION_POSITION;
                            contentData.Header = data.QUESTIONS[i];
                            dispatch    = false;
                        }
                    }
                    
                    else if (data.QUESTIONS[i].QUESTION_TYPE_ID === 1) {
                        if (!dispatch && contentData) {
                            contentData.Content.push(data.QUESTIONS[i]);
                        }
                        else {
                            mainData.push({
                                Type: data.QUESTIONS[i].QUESTION_TYPE_ID,
                                Position: data.QUESTIONS[i].QUESTION_POSITION,
                                Header: data.QUESTIONS[i],
                                Content: data.QUESTIONS[i]
                            });
                        }
                    }

                    else {
                        if (!dispatch) {
                            mainData.push({
                                Type: data.QUESTIONS[i].QUESTION_TYPE_ID,
                                Position: data.QUESTIONS[i].QUESTION_POSITION,
                                Header: data.QUESTIONS[i],
                                Content: data.QUESTIONS[i]
                            });
                            mainData.push(contentData);
                            contentData = blankContent();
                            contentData = null;
                            dispatch    = true;
                        }
                        else {
                            mainData.push({
                                Type: data.QUESTIONS[i].QUESTION_TYPE_ID,
                                Position: data.QUESTIONS[i].QUESTION_POSITION,
                                Header: data.QUESTIONS[i],
                                Content: data.QUESTIONS[i]
                            });
                        }
                    }
                }
                setDataSet(mainData);
            }
        };        
        */
        const parseData = async () => {
            if (data?.SESSION_QUESTIONS) {
                let contentType6 = null;
                let contentType1 = null;
                let mainData = [];
                let dispatchType6 = true;
                let dispatchType1 = true;

                for (let i = 0; i < data.SESSION_QUESTIONS.length; i++) {
                    const q = data.SESSION_QUESTIONS[i];

                    // Group start for TYPE 6
                    if (q.QUESTION_TYPE_ID === 6) {
                        if (contentType6 !== null) {
                            mainData.push(contentType6);
                        }
                        contentType6 = blankContent();
                        contentType6.Type = 6;
                        contentType6.Position = q.QUESTION_POSITION;
                        contentType6.Header = q;
                        dispatchType6 = false;
                        continue;
                    }

                    // Group start or continuation for TYPE 1
                    if (q.QUESTION_TYPE_ID === 1) {
                        if (!dispatchType6 && contentType6) {
                            contentType6.Content.push(q);
                        } else if (!dispatchType1 && contentType1) {
                            contentType1.Content.push(q);
                        } else {
                            if (contentType1 === null) {
                                contentType1 = blankContent();
                                contentType1.Type = 1;
                                contentType1.Position = q.QUESTION_POSITION;
                                contentType1.Header = q;
                                contentType1.Content.push(q);
                                dispatchType1 = false;
                            } else {
                                contentType1.Content.push(q);
                            }
                        }
                        continue;
                    }

                    // Other QUESTION_TYPE_IDs
                    const standalone = {
                        Type: q.QUESTION_TYPE_ID,
                        Position: q.QUESTION_POSITION,
                        Header: q,
                        Content: q
                    };

                    if (!dispatchType6 && contentType6) {
                        mainData.push(standalone);
                        mainData.push(contentType6);
                        contentType6 = null;
                        dispatchType6 = true;
                    } else if (!dispatchType1 && contentType1) {
                        mainData.push(standalone);
                        mainData.push(contentType1);
                        contentType1 = null;
                        dispatchType1 = true;
                    } else {
                        mainData.push(standalone);
                    }
                }

                // Push any remaining groups
                if (contentType6 !== null) {
                    mainData.push(contentType6);
                }
                if (contentType1 !== null) {
                    mainData.push(contentType1);
                }

                function swap(arr, i, j) {
                    let temp = arr[i];
                    arr[i] = arr[j];
                    arr[j] = temp;
                }
                function sort(arr) {
                    let n = arr.length;
                    for (let i = 0; i < n - 1; i++) {
                        let swapped = false;
                        for (let j = 0; j < n - i - 1; j++) {
                            if (arr[j].Position > arr[j + 1].Position) {
                                swap(arr, j, j + 1);
                                swapped = true;
                            }
                        }
                        if (!swapped) break;
                    }
                    return arr;
                }

                setDataSet(sort(mainData));
            }
        };
        
        parseData();
    }, [data]);

    return (
        <>
            {data.SESSION_LINES.length > 0 &&(
                <React.Fragment>
                    <div className={MainStyle.my_3}>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg}>
                                <div className={[MainStyle.rounded_5, MainStyle.border].join(" ")} style={{backgroundColor: "#e6e6e6"}}>
                                    <div className={[MainStyle.mx_3, MainStyle.py_3].join(" ")}>
                                        < div className={MainStyle.row}>
                                            {firstHalf && (
                                                <div className={MainStyle.col}>
                                                    {firstHalf.map((session_line, i) => {
                                                        return (
                                                            <SessionLine
                                                                data={session_line}
                                                                index={i}
                                                                lang={lang}
                                                                fontSize={fontSize}
                                                            />
                                                        );
                                                    })}
                                                </div>
                                            )}
                                            {secondHalf && (
                                                <div className={MainStyle.col}>
                                                    {secondHalf.map((session_line, i) => {
                                                        return (
                                                            <SessionLine
                                                                data={session_line}
                                                                index={i}
                                                                lang={lang}
                                                                fontSize={fontSize}
                                                            />
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={MainStyle.my_3}>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg}>
                                <div className={[MainStyle.text_center, MainStyle.text_pre_wrap].join(" ")}>
                                    <span className={[MainStyle[`fs_${fontSize}`]].join(" ")}>
                                        {orderData[`SUBTI_LANG_${lang}_DESC`]?.replaceAll('|n|', '\n')}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )}
            <div className={MainStyle.my_3}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        {dataSet?.map((block) => {
                            if (block.Type === 1) {
                                return (
                                    <React.Fragment>
                                        <QType_1
                                            orderData={orderData}
                                            lang={lang}
                                            fontSize={fontSize}
                                            block={block}
                                        />
                                        <DefaultPadding/>
                                    </React.Fragment>
                                );
                            }
                            else if (block.Type === 2) {
                                return (
                                    <React.Fragment>
                                        <QType_2
                                            orderData={orderData}
                                            lang={lang}
                                            fontSize={fontSize}
                                            block={block}
                                        />
                                        <DefaultPadding/>
                                    </React.Fragment>
                                );
                            }
                            else if (block.Type === 3) {
                                return (
                                    <React.Fragment>
                                        <QType_3
                                            orderData={orderData}
                                            lang={lang}
                                            fontSize={fontSize}
                                            block={block}
                                        />
                                        <DefaultPadding/>
                                    </React.Fragment>
                                );
                            }
                            else if (block.Type === 4) {
                                return (
                                    <React.Fragment>
                                        <QType_4
                                            orderData={orderData}
                                            lang={lang}
                                            fontSize={fontSize}
                                            block={block}
                                        />
                                        <DefaultPadding/>
                                    </React.Fragment>
                                );
                            }
                            else if (block.Type === 5) {
                                return (
                                    <React.Fragment>
                                        <PageBreak/>
                                        <QType_5
                                            orderData={orderData}
                                            lang={lang}
                                            fontSize={fontSize}
                                            block={block}
                                        />
                                        <DefaultPadding/>
                                    </React.Fragment>
                                );
                            }
                            else if (block.Type === 6) {
                                return (
                                    <React.Fragment>
                                        <QType_6
                                            orderData={orderData}
                                            lang={lang}
                                            fontSize={fontSize}
                                            block={block}
                                        />
                                        <DefaultPadding/>
                                    </React.Fragment>
                                );
                            }
                        })}
                    </div>
                </div>
            </div>
        </>
    );
});
//#endregion

// #region Orders
const OrderBlock = React.memo(({...other}) => {
    const { data,
            lang,
            fontSize                 } = other;

    const [orderLang, setOrderLang]    = useState(null);
    const [orderData, setOrderData]    = useState(null);
    
    useEffect(() => {
        const setData =  async () => {
            if (data && lang) {  
                if ((data.LANG_PT === "Y") && (lang === "PT")) {
                    setOrderLang("PT");
                }
                else if ((data.LANG_EN === "Y") && (lang === "EN")) {
                    setOrderLang("EN");
                }
                else if ((data.LANG_ES === "Y") && (lang === "ES")) {
                    setOrderLang("ES");
                }
                else {
                    if ((data.LANG_PT === "Y")) {
                        setOrderLang("PT");
                    }
                    else if ((data.LANG_EN === "Y")) {
                        setOrderLang("EN");
                    }
                    else if ((data.LANG_ES === "Y")) {
                        setOrderLang("ES");
                    }
                }
                setOrderData(data);            
            }
        };
        setData();
    },[data, lang, fontSize]);

    return (
        <>
            <div className={MainStyle.row}>
                <div className={MainStyle.col}>
                    <HeaderBlock
                        data={orderData}
                        lang={orderLang}
                        fontSize={fontSize}
                    />
                </div>
                <div className={MainStyle.col}>
                    <InfoBlock
                        data={orderData}
                        lang={orderLang}
                        fontSize={fontSize}
                    />
                </div>

            </div>
            <DefaultPadding />
            {
                orderData?.SESSIONS.map((session, i) => {
                    return (
                        <React.Fragment>
                            <SessionBlock
                                orderData={orderData}
                                data={session}
                                lang={orderLang}
                                fontSize={fontSize}
                            />
                            { (i + 1) === orderData?.SESSIONS?.length ? null : <PageBreak/>}
                        </React.Fragment>
                    );
                })
            }
        </>
    );
});
// #endregion

const ExportedContent = React.memo(({...other}) => {
    const {data, fontSize, lang } = other;

    useEffect(() => {},[data, fontSize, lang]);
    return (
        <div>
            {data?.map((order, i) => {
                return (
                    <React.Fragment key={order.ORDER_ID}>
                        <OrderBlock data={order} lang={lang} fontSize={fontSize}/>
                        { (i + 1) === data?.length ? null : <PageBreak/>}
                    </React.Fragment>
                );
            })}
        </div>
    );
});

export const AggregatedReportDocument = ({...other}) => {
    const { dataSet                 }  = other;
    const [ data,       setData     ]  = useState(null); 
    const [ lang,       setLang     ]  = useState(null);             // Lang Control
    const [ langList,   setLangList ]  = useState(null);             // Lang List Control
    const [ fontSize,   setFontSize ]  = useState(6);
    const { showLoader, hideLoader  }  = useLoader();                // Control over the loader
    const { showInfoMessage         }  = useInfoMsgModal();          // Modal message control 
    const { showToastMessage        }  = useToastMessage();  
    const ElementRef                   = useRef(null);
    const [ fileName, setFileName   ]  = useState(null);

    useEffect(() => {
        const fetchData = async (dataSet) => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: "Aguarde carregando..."});
                let fetchedData = await getOrdersResByIDSet(dataSet);
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;
                            if (fetchedData) {
                                setLangList([
                                    { value: 'PT', label: 'Português' },
                                    { value: 'EN', label: 'English' },
                                    { value: 'ES', label: 'Español' }
                                ]);
                                setLang('PT');
                                if (fetchedData.length === 1) {
                                    let file_name = `${toSafeFilename(fetchedData[0].ORDER_DESC)}_id_${fetchedData[0].ORDER_ID}.pdf`;
                                    setFileName(file_name);
                                }
                                else {
                                    setFileName(`Avaliacoes_${(Date.now()).toString()}.pdf`);
                                }                                
                            }

                            setData(fetchedData);
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': "Oops", 'message': fetchedData.status.message});
                    }                    
                }
            } 
            catch (error) {
                console.warn(`Error Trace: ${error}`);
                setData({});
            }
        };
        fetchData(dataSet);
    }, [dataSet]);
    
    const LanguageSelector = React.memo(() => {
        return (
            <div className={MainStyle.m_3}>
                <DropdownList
                    value={langList?.find((i) => i.value === lang)}
                    listOfItems={langList}
                    style={{ width: "100%" }}
                    className={[MainStyle.mt_2, MainStyle.text_center].join(" ")}
                    onChange={(event) => {setLang(event);}}
                />
            </div>
        );
    });

    const FontSizeSelector = React.memo(() => {
        let fontList =[
            {value: 5, label: GetLabel(appLang, 505)},
            {value: 6, label: GetLabel(appLang, 503)},
            {value: 7, label: GetLabel(appLang, 504)},
        ];
        return (
            <div className={MainStyle.m_3}>
                <DropdownList
                    value={fontList?.find((i) => i.value === fontSize)}
                    listOfItems={fontList}
                    style={{ width: "100%" }}
                    className={[MainStyle.mt_2, MainStyle.text_center].join(" ")}
                    onChange={(event) => {setFontSize(event);}}
                />
            </div>
        );
    });

    const ThemeSelector = React.memo(() => {
        return (
            <div className={MainStyle.m_3}>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                    <BtnChangeTheme/>
                </div>
            </div>
        );
    });

    const BtnDownload = React.memo(() => {
        return (
            <div className={MainStyle.m_3}>
                <div onClick={() => { 
                    showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 538)});
                    ElementRef.current.save();
                    }}
                >
                    <div className={[MainStyle.py_3, MainStyle.shadow_sm, MainStyle.border, MainStyle.rounded, MainStyle.btn_blue, MainStyle.text_center].join(" ")} >
                        <span className={[MainStyle.fs_6, MainStyle.text_white].join(" ")}>
                            Download
                        </span>
                    </div>
                </div>
            </div>
        );
    });

    const footerTemplate = React.memo((props) => {
        return (
            <div style={{position: 'absolute', bottom: '5px', left: '0', right: '0'}}>
                <div className={MainStyle.mx_5}>
                    <div className={[MainStyle.row].join(" ")}>
                        <div className={[MainStyle.col_8].join(" ")}>
                                <p style={{color: "rgb(110, 110, 110)"}}>
                                    {GetLabel(lang, 518)}
                                </p>
                        </div>
                        <div className={[MainStyle.col, MainStyle.text_end].join(" ")}>
                                <p style={{color: "rgb(110, 110, 110)    "}}>
                                    {props.pageNum} {GetLabel(lang, 44)} {props.totalPages}
                                </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    });

    return (
        <>
            <div className={[MainStyle.border_bottom, MainStyle.shadow_sm].join(" ")}>
                <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                    <div className={MainStyle.col_lg_1}>
                        <ThemeSelector/>
                    </div>                                
                    <div className={MainStyle.col_lg_2}>
                        <LanguageSelector/>
                    </div>
                    <div className={MainStyle.col_lg_2}>
                        <FontSizeSelector/>
                    </div>
                    <div className={MainStyle.col_lg_7}>
                        <BtnDownload/>
                    </div>                                                              
                </div>
            </div>
            <DefaultPadding/>
            <div>
                <PDFExport
                    ref={ElementRef} 
                    scale={0.5}
                    paperSize={"A4"}
                    fileName={fileName}
                    content="text/html; charset=utf-8"
                    forcePageBreak=".page-break"
                    pageTemplate={footerTemplate}
                >
                    <PDFMargin top="10mm" left="10mm" right="10mm" bottom="10mm"/>
                    <div className={"force_pdf_style"}>
                        <div className={MainStyle.mx_3}>
                            <ExportedContent data={data} setData={setData} fontSize={fontSize} lang={lang}/>
                        </div>
                    </div>
                </PDFExport>
                <DefaultPadding/>
            </div>
        </>
    );
};